module.exports = __webpack_public_path__ + "img/6529f9d.png";